module.exports = __webpack_public_path__ + "static/img/dm.4cb659a7.svg";